import React from 'react';
import { useDispatch } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { reduxForm, Field } from 'redux-form/immutable';

import Box from 'retired/Box';
import FormTextField from 'retired/FormTextField';
import FormFieldLabel from 'retired/FormFieldLabel';
import { required, isEmail } from 'utils/validators';
import { useInjectEpics } from 'utils/injectEpics';
import FormCheckbox from 'retired/FormCheckbox';
import { currencies } from 'utils/currencyFormat';
import FormSelectRedesign from 'retired/FormSelectRedesign';

import { NEW_COMPANY_FORM_IDENTIFIER } from './constants';
import * as Actions from './actions';
import epics from './epics';

const requiredValidator = required();
const isEmailValidator = isEmail();

const key = 'userPage';

const NewCompanyForm = ({ handleSubmit, submitting, invalid, pristine }) => {
  useInjectEpics({ key, epics });
  const dispatch = useDispatch();

  const createNewCompany = (data) => {
    dispatch(Actions.createNewCompanyAction({ ...data.toJS() }));
  };

  /**
   * Note: @BI
   * Donex Team: Currently only allow USD
   */

  const supportedGivingAccountCurrencies = [currencies.USD];

  return (
    <Box style={{ maxWidth: 1200, marginTop: 30 }}>
      <form onSubmit={handleSubmit(createNewCompany)}>
        <fieldset>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <FormFieldLabel forName="newCompanyName">Create a New Company</FormFieldLabel>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <Field
                    id="newCompanyName"
                    name="newCompanyName"
                    component={FormTextField}
                    required
                    fullWidth
                    label="Company Name"
                    validate={[requiredValidator]}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    id="newCompanyUserName"
                    name="newCompanyUserName"
                    component={FormTextField}
                    required
                    fullWidth
                    label="Company User Name"
                    validate={requiredValidator}
                  />
                  <Field
                    id="newCompanyUserEmail"
                    name="newCompanyUserEmail"
                    component={FormTextField}
                    required
                    fullWidth
                    label="Company User Email"
                    validate={[requiredValidator, isEmailValidator]}
                    style={{ marginTop: 20 }}
                  />
                </Grid>
              </Grid>

              <Typography style={{ marginTop: '2rem', marginBottom: '3rem' }}>
                Company Giving Account Information
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <Field
                    name="enableCompanyGivingAccount"
                    component={FormCheckbox}
                    label="Enable Company Giving Account"
                    normalize={(value: boolean | undefined) => !!value}
                    style={{ marginTop: '0.5rem' }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Field
                    name="companyAccountCurrency"
                    component={FormSelectRedesign}
                    label="Company Giving Account Currency"
                    fullWidth
                  >
                    {supportedGivingAccountCurrencies.map((option) => {
                      const { code: value, label: name } = option;
                      return (
                        <MenuItem key={value} value={value}>
                          {name}
                        </MenuItem>
                      );
                    })}
                  </Field>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <br />
          <br />
          <Typography align="right">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={invalid || submitting || pristine}
              onClick={handleSubmit(createNewCompany)}
            >
              Submit
            </Button>
          </Typography>
        </fieldset>
      </form>
    </Box>
  );
};

const withForm = reduxForm({
  form: NEW_COMPANY_FORM_IDENTIFIER,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
});
export default withForm(NewCompanyForm);
